export const passwordRegExp =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+.])\S{8,}$/;
export const emailRegExp = /^[\w-\.]+@([\w-]+\.)+[a-z]+$/;
export const nameRegExp = /^[\p{L} '-]+$/u;
